import React from 'react'
import {connect} from 'react-redux'

import {
  PRESENCE,
  PRESENCE_COLORS
} from './config/constants'

import {
  watchCurrentUserPresence,
  unwatchCurrentUserPresence
} from './data/watchers/user_presence'

class PresenceIndicator extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isWatching: false
    }
  }

  componentWillMount () {
    if (this.props.user && this.props.user.uid && (typeof(this.props.presence) !== 'number' || this.props.shouldForceWatch)) {
      this.props.onComponentLoaded(this.props.user.uid)
      this.setState({isWatching: true})
    }
  }

  componentWillReceiveProps (nextProps) {
    const user = nextProps.user || this.props.user

    if (user && user.uid && typeof(nextProps.presence) !== 'number' && !this.state.isWatching) {
      this.props.onComponentLoaded(user.uid)
    }
  }

  componentWillUnmount () {
    if (this.state.isWatching) {
      this.props.onComponentUnLoaded(this.props.user.uid)
    }
  }

  presenceColor (presence) {
    if (!presence || (typeof presence === 'object' && Object.keys(presence).length === 0)) {
      presence = PRESENCE.OFFLINE
    }

    return PRESENCE_COLORS[presence]
  }

  render () {
    return (
      <div className={'presence-indicator'} style={{backgroundColor: this.presenceColor(this.props.presence), height: this.props.size, width: this.props.size}}>
      </div>
    )
  }
}

PresenceIndicator.defaultProps = {
  size: 10,
  presence: PRESENCE.OFFLINE
}

const mapStateToProps = (state, ownProps) => {
  let presence = ownProps.presence

  if (ownProps.user && ownProps.user.uid) {
    presence = state.getIn(['presences', ownProps.user.uid])
  }

  return {
    presence
  }
}

const mapDispatchToProps = () => {
  return {
    onComponentLoaded: watchCurrentUserPresence,
    onComponentUnLoaded: unwatchCurrentUserPresence
  }
}

const PresenceIndicatorContainer = connect(
  mapStateToProps, mapDispatchToProps
)(PresenceIndicator)

export default PresenceIndicatorContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/presence_indicator.js
 **/